import { useQuery } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useSponsoredCollectionCode = (
  collectionId?: string,
  enabled?: boolean,
) => {
  return useQuery({
    queryKey: ["sponsoredCollectionCode", collectionId],
    queryFn: () =>
      collectionApiClient.getSponsoredCollectionCode(collectionId!),
    enabled: !!collectionId && !!enabled,
  });
};

export default useSponsoredCollectionCode;
